export const PURPLE = "#4956B9";
export const LIGHT_PURPLE = "#6A74C5";
export const COOL_PURPLE = "rgb(89, 105, 226)";
